import { NOT_DONE_JOB_STATUSES, DONE_JOB_STATUSES } from 'screens/Task/lib/constants';
import { Job } from 'screens/Task/lib/types';

export const isNotDone = (job: Job) => NOT_DONE_JOB_STATUSES.includes(job.status);

export const isDone = (job: Job) => DONE_JOB_STATUSES.includes(job.status);
